import { create } from 'zustand';
import { ACHIEVEMENTS, knownAchievements } from '../models/achievements';

interface AlertState {
  /** Known ids seen so far this session; `null` until the first payload. Only ever grows. */
  baseline: ReadonlySet<string> | null;
  /** Known ids earned but not yet acknowledged, in display order. */
  pending: string[];
  /** Take the achievements of an accepted player payload; `null` forgets everything (sign-out). */
  observe: (ids: readonly string[] | null) => void;
  dismiss: () => void;
}

export const useAchievementAlerts = create<AlertState>((set, get) => ({
  baseline: null,
  pending: [],
  observe: (ids) => {
    if (ids == null) {
      set({ baseline: null, pending: [] });
      return;
    }
    const known = new Set(knownAchievements(ids).map((a) => a.id));
    const { baseline, pending } = get();
    if (baseline == null) {
      set({ baseline: known });
      return;
    }
    const fresh = [...known].filter((id) => !baseline.has(id));
    if (fresh.length === 0) return;
    const union = new Set([...baseline, ...known]);
    const queued = new Set([...pending, ...fresh]);
    set({ baseline: union, pending: ACHIEVEMENTS.map((a) => a.id).filter((id) => queued.has(id)) });
  },
  dismiss: () => set({ pending: [] }),
}));
